import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";
import {
  FooterContainer,
  FooterLinkItems,
  FooterLinksContainer,
  FooterLinksWrapper,
  FooterLinkTitle,
  FooterWrap,
  FooterLink,
  SocialMedia,
  SocialMediaWrap,
  SocialLogo,
  WebsiteRights,
  SocialIconLink,
  SocialIcons,
} from "./FooterElements";
import { animateScroll as scroll } from "react-scroll";

const Footer = () => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  return (
    <FooterContainer>
      <FooterWrap>
        <FooterLinksContainer>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>About Us</FooterLinkTitle>
              <FooterLink to="./signin">How it works</FooterLink>
              <FooterLink to="./signin">Testimonials</FooterLink>
              <FooterLink to="./signin">Careers</FooterLink>
              <FooterLink to="./signin">Investors</FooterLink>
              <FooterLink to="./signin">Terms of Service</FooterLink>
            </FooterLinkItems>
            <FooterLinkItems>
              <FooterLinkTitle>Contact Us</FooterLinkTitle>
              <FooterLink to="./signin">Contact</FooterLink>
              <FooterLink to="./signin">Support</FooterLink>
              <FooterLink to="./signin">Destinations</FooterLink>
              <FooterLink to="./signin">Sponsorship</FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
          <FooterLinksWrapper>
            <FooterLinkItems>
              <FooterLinkTitle>Videos</FooterLinkTitle>
              <FooterLink to="./signin">Submit Video</FooterLink>
              <FooterLink to="./signin">Ambassadors</FooterLink>
              <FooterLink to="./signin">Agency</FooterLink>
              <FooterLink to="./signin">Influencer</FooterLink>
            </FooterLinkItems>
            <FooterLinkItems>
              <FooterLinkTitle>Social Media</FooterLinkTitle>
              <FooterLink to="./signin">Instagram</FooterLink>
              <FooterLink to="./signin">Facebook</FooterLink>
              <FooterLink to="./signin">Youtube</FooterLink>
              <FooterLink to="./signin">Twitter</FooterLink>
            </FooterLinkItems>
          </FooterLinksWrapper>
        </FooterLinksContainer>
        <SocialMedia>
          <SocialMediaWrap>
            <SocialLogo to="/" onClick={toggleHome}>
              dolla
            </SocialLogo>
            <WebsiteRights>
              dolla &copy; {new Date().getFullYear()} All rights reserved.
            </WebsiteRights>
            <SocialIcons>
              <SocialIconLink href="#">
                <FaFacebook />
              </SocialIconLink>
              <SocialIconLink href="#">
                <FaInstagram />
              </SocialIconLink>
              <SocialIconLink href="#">
                <FaYoutube />
              </SocialIconLink>
              <SocialIconLink href="#">
                <FaTwitter />
              </SocialIconLink>
            </SocialIcons>
          </SocialMediaWrap>
        </SocialMedia>
      </FooterWrap>
    </FooterContainer>
  );
};

export default Footer;
